import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const PrePrimarySchool = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className="container mx-auto px-6 py-12">
            {/* Heading */}
            <h1 className="md:text-3xl text-2xl  font-bold text-center mb-6">SVN CONVENT PRE-PRIMARY SCHOOL
            NURSERY, LKG, UKG</h1>
            <h2 className="md:text-2xl text-xl font-bold text-center mb-6">NURSERY, LKG, UKG</h2>

           {/* Description */}
<div className="flex flex-col md:flex-row items-center justify-center  md:text-left my-12" data-aos="fade-up">
    {/* Image Section */}
    <div className="md:w-1/2 flex justify-center">
        <img 
            src="https://img.freepik.com/premium-photo/happy-teachers-day-background-290_936147-4442.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" 
            alt="Pre-Primary Learning" 
            className="w-full md:w-4/5 rounded-lg shadow-md"
        />
    </div>

    {/* Text Section */}
    <div className="md:w-1/2 flex items-center justify-center ">
        <p className="text-lg md:mt-0 mt-10 text-gray-700 leading-relaxed">
            Our Pre-Primary School provides a nurturing and engaging environment for young learners in 
            Pre-Nursery, LKG, and UKG. Through play-based learning, interactive activities, and creative 
            teaching methods, we ensure a strong foundation for cognitive, social, and emotional development.
            The curriculum focuses on basic literacy, numeracy, motor skills, and overall personality growth.
        </p>
    </div>
</div>


            {/* Content Section */}
            <div className="flex flex-col md:flex-row items-center my-12 md:items-start" data-aos="fade-up">
                {/* Left Content */}
                <div className="md:w-1/2 text-left">
                    <h2 className="text-2xl font-semibold mb-4">Teaching Methodology</h2>
                    <p className="text-lg text-gray-700 leading-relaxed mb-6">
                        Our Pre-Primary School focuses on interactive and play-based learning techniques. 
                        Activities such as storytelling, singing, and role-playing enhance cognitive and 
                        social development. We encourage curiosity, creativity, and foundational skill-building.
                    </p>
                    <h2 className="text-2xl font-semibold mb-4">Learning at Pre-Primary</h2>
                    <p className="text-lg text-gray-700 leading-relaxed">
                        The curriculum integrates hands-on experiences, outdoor play, and 
                        group activities to foster holistic growth. Children engage in fine motor skills 
                        development, early literacy, numeracy, and collaborative learning.
                    </p>
                </div>

                {/* Right Image */}
                <div className="md:w-1/2 flex justify-center mt-6 md:mt-0">
                    <img 
                        src="https://img.freepik.com/premium-photo/indian-couple-volunteering-as-guest-readers-kindergarten-classroom-sharing-their-love-storytelling-inspiring-young-learners-with-tales-adventure-imagination_748982-25703.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" 
                        alt="Pre-Primary Learning" 
                        className="w-full md:w-4/5 rounded-lg shadow-md"
                    />
                </div>
            </div>

             {/* Facilities Section */}
             <h2 className="text-2xl font-bold text-center mt-12 mb-6">Facilities for Pre-Primary</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 mb-6 gap-6" data-aos="fade-up">
                {/* Card 1 */}
                <div className="bg-white shadow-md rounded-lg p-6 text-center">
                    <img src="https://img.freepik.com/free-vector/children-kindergarten-having-fun_1308-94762.jpg" alt="Play Area" className="w-full h-40 object-cover rounded-md mb-4"/>
                    <h3 className="text-xl font-semibold">Safe Play Area</h3>
                    <p className="text-gray-600 mt-2">Our pre-primary school has a dedicated play area to encourage physical activity and social skills.</p>
                </div>

                {/* Card 2 */}
                <div className="bg-white shadow-md rounded-lg p-6 text-center">
                    <img src="https://img.freepik.com/free-vector/flat-kids-learning-draw-cartoon_1308-65523.jpg" alt="Creative Learning" className="w-full h-40 object-cover rounded-md mb-4"/>
                    <h3 className="text-xl font-semibold">Creative Learning</h3>
                    <p className="text-gray-600 mt-2">Engaging storytelling, music, and hands-on activities make learning enjoyable for young minds.</p>
                </div>

                {/* Card 3 */}
                <div className="bg-white shadow-md rounded-lg p-6 text-center">
                    <img src="https://img.freepik.com/free-vector/kids-learning-alphabet-numbers_1308-87765.jpg" alt="Montessori Approach" className="w-full h-40 object-cover rounded-md mb-4"/>
                    <h3 className="text-xl font-semibold">Montessori Approach</h3>
                    <p className="text-gray-600 mt-2">We follow Montessori techniques to help children learn at their own pace with fun and interactive methods.</p>
                </div>
            </div>

            {/* Image Grid */}
            <h2 className="text-2xl font-bold text-center mt-12 mb-6">Gallery</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-8" data-aos="fade-up">
                <img src="https://img.freepik.com/free-vector/kids-learning-alphabet_1308-117487.jpg" alt="Alphabet Learning" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/kids-playing-playground_1308-106860.jpg" alt="Playground Activities" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/kids-storytelling-classroom_1308-126077.jpg" alt="Storytelling Session" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/kids-doing-crafts_1308-93125.jpg" alt="Creative Activities" className="w-full h-48 object-cover rounded-lg shadow-md" />
            </div>
        </div>
    );
}

export default PrePrimarySchool;
